import React, { useContext, useEffect, useState } from 'react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import TrashIcon from '../../../assets/trash-icon.svg'
import SwapIconUp from '../../../assets/swap-arrow-icon-up.svg'
import SwapIconDown from '../../../assets/swap-arrow-icon.svg'

const RosemaryCategoriesChildCard = ({
  data,
  index,
  categoryList,
  isEdit,
  setChildContent,
  validationError,
  clearError,
  onSwap,
  onDelete,
  swapRender,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const [childObj, setChildObj] = useState({
    image_s3key: '',
    header: '',
    sub_header: '',
    link: {
      type: '',
      data: {},
    },
  })

  const [errorData, setErrorData] = useState({})
  const [childImageData, setChildImagData] = useState([])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: `childImg${index}`,
        width: 200,
        height: 124,
        divwidth: '9rem',
        divheight: '6rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('image')
          setChildObj((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
          //   setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setChildObj((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        imagePaddingX: '7px',
        imagePaddingY: '7px',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '7px',
        btnMarginTop: '5px',
      },
    ]

    if (isEdit) {
      setChildObj(data)
      imgData[0]['assetId'] = data.image_s3key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        data.image_s3key,
      )
    }
    setChildImagData(imgData)
  }, [swapRender])

  useEffect(() => {
    setChildContent(index, childObj)
  }, [childObj])

  return (
    <div
      style={{
        borderRadius: '4px',
        boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.3)',
        backgroundColor: '#eee',
      }}
      className="px-4 py-3 my-4"
    >
      <div className="d-flex w-100 justify-content-between 2xl:mt-2">
        <div>
          <h6 style={{ fontSize: '12px' }}>Content Thumbnail</h6>
          <div className="text-center ">
            <ImageUploader data={childImageData} />
            <span className="mt-2 " style={{ fontSize: '11px', color: '#707070' }}>
              Size: 200px X 124px
            </span>
          </div>
          <div className="message-text error-message text-center">
            <p>{validationError?.image}</p>
          </div>
        </div>
        <div style={{ width: '76%' }} className="">
          <div className="d-flex justify-content-end">
            <div
              className="mx-1 h-[23px] w-[23px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
              onClick={() => onSwap(index, 'down')}
              // onClick={() => setSwapType('down')}
              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
            >
              <img src={SwapIconDown} className="w-[13px] h-[13px]" alt="trashicon" />
            </div>
            <div
              className="mx-1 h-[23px] w-[23px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
              onClick={() => onSwap(index, 'up')}
              // onClick={() => setSwapType('up')}
              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
            >
              <img src={SwapIconUp} className="w-[13px] h-[13px]" alt="trashicon" />
            </div>
            <div
              className="mx-1 h-[23px] w-[23px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
              onClick={() => onDelete(index)}
              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
            >
              <img src={TrashIcon} className="w-[13px] h-[13px]" alt="trashicon" />
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div style={{ width: '48%' }}>
              <h6 style={{ fontSize: '12px' }}>Header</h6>
              <CustomDescriptionBox
                limit={80}
                rows={1}
                value={childObj.header}
                onChange={(value) => setChildObj((prev) => ({ ...prev, header: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
                isMandatory={true}
                errorText={validationError?.header}
              />
            </div>
            <div style={{ width: '48%' }}>
              <h6 style={{ fontSize: '12px' }}>Sub-header</h6>
              <CustomDescriptionBox
                limit={65}
                rows={1}
                value={childObj.sub_header}
                onChange={(value) => setChildObj((prev) => ({ ...prev, sub_header: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
        </div>
      </div>
      <AttachLink
        linkData={childObj.link}
        id={'ctaButton'}
        categoryData={
          categoryList
            ? categoryList.filter((info, idx) => info.type === 'category' && info.status)
            : []
        }
        setLinkData={(value) => {
          // clearError('ctaButtonLink')
          setChildObj((prev) => ({ ...prev, link: value }))
        }}
        selectorWidth={'76%'}
      />
      <div className="message-text error-message">
        <p>{errorData?.link}</p>
      </div>
    </div>
  )
}

export default RosemaryCategoriesChildCard
